import { Pipe, inject, type PipeTransform } from '@angular/core';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlightSearch',
})
export class HighlightSearchPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(text: string, query: string, minLength = 2): SafeHtml {
    if (!text) {
      return '';
    }

    const trimmedQuery = query.trim() || '';

    if (trimmedQuery.length < minLength) {
      return text;
    }

    const escapedQuery = trimmedQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedQuery})`, 'gi');

    const highlightedText = text.replace(regex, (match) => `<mark class="search-highlight">${match}</mark>`);

    return this.sanitizer.bypassSecurityTrustHtml(highlightedText);
  }
}
